import { AdminTeamAiSkillsWorkspace } from '@/components/features/admin-team-ai-skills/admin-team-ai-skills.workspace';
import { PageHeader } from '@/components/layout/PageHeader';

export default function AdminTeamAiSkillsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Team AI PM Skills"
        description="Version, evaluate, publish, and assign bounded planning instructions for Team AI V2."
      />
      <AdminTeamAiSkillsWorkspace />
    </div>
  );
}
